import { delay } from 'redux-saga/effects';

const DEFAULT_MAX_RETRY_COUNT = 5;

export const getExponentialBackOffDelay =
    (initialDelay = 100, maxDelay = 1000, exp = 2) =>
    (retryNumber) => {
        return Math.min(Math.pow(exp, retryNumber) * initialDelay, maxDelay);
    };

export function* retrySaga(
    sagaToRetry,
    getDelay = getExponentialBackOffDelay(),
    maxRetryCount = DEFAULT_MAX_RETRY_COUNT
) {
    for (let i = 0; i <= maxRetryCount; i += 1) {
        try {
            return yield sagaToRetry();
        } catch (error) {
            if (i < maxRetryCount) {
                yield delay(getDelay(i));
            } else {
                throw error;
            }
        }
    }
    throw 'Error in retrySaga';
}

export function* retrySagaList(sagaListToRetry, getDelay, maxRetryCount) {
    for (let i = 0; i < sagaListToRetry.length; i += 1) {
        yield retrySaga(sagaListToRetry[i], getDelay, maxRetryCount);
    }
}
